export const DefaultPosition = 'right';

export interface WebchatConfig {
  name: string;
  color: string;
  isEnabled: boolean;
  welcomeMessage: string;
  textColor: string;
  accentColor: string;
  accentTextColor: string;
  skipContactCapture: boolean;
  widgetTopSpace: number;
  assistantName: string;
  assistantAvatarUrl: string | null;
  position: 'right' | 'left';
  showMobileCta: boolean;
  customGreetingMessage: string;
  enableGreetingMessage: boolean;
  showFooterContent: boolean;
  poweredByName: string;
  poweredByUrl: string | null;
  namespace: string;
}
